import { PublicKey } from '@solana/web3.js';
import { buildProgram as buildProgramHelper } from './helpers.js';
import { SolanaHTLCPublicClient } from './PublicClient.js';
import { userLock as userLockFn } from './wallet/userLock.js';
import { refund as refundFn } from './wallet/refund.js';
import { redeemSolver as redeemSolverFn } from './wallet/redeemSolver.js';
import { buildUserLockTx as buildUserLockTxFn } from './wallet/buildUserLockTx.js';
import { buildRefundTx as buildRefundTxFn } from './wallet/buildRefundTx.js';
import { buildRedeemSolverTx as buildRedeemSolverTxFn } from './wallet/buildRedeemSolverTx.js';
export class SolanaHTLCWalletClient extends SolanaHTLCPublicClient {
    constructor(config) {
        super(config);
        this.signer = config.signer;
    }
    buildProgram(contractAddress, readerKey, connection) {
        return buildProgramHelper(contractAddress, connection ?? this.connection, readerKey ?? new PublicKey(this.signer.publicKey));
    }
    // ── Write Operations ───────────────────────────────────────────────
    async userLock(params) {
        const walletPublicKey = new PublicKey(this.signer.publicKey);
        const program = this.buildProgram(params.atomicContract, walletPublicKey);
        return userLockFn(this.connection, this.signer, params, program);
    }
    async refund(params) {
        const walletPublicKey = new PublicKey(this.signer.publicKey);
        const program = this.buildProgram(params.contractAddress, walletPublicKey);
        return refundFn(this.connection, this.signer, params, program);
    }
    async redeemSolver(params) {
        const walletPublicKey = new PublicKey(this.signer.publicKey);
        const program = this.buildProgram(params.contractAddress, walletPublicKey);
        return redeemSolverFn(this.connection, this.signer, params, program);
    }
    // ── Transaction Builders ──────────────────────────────────────────
    // Return unsigned, blockhash-attached `Transaction` objects ready to
    // sign/send. Useful for integrators who want to sign/submit via their
    // own infrastructure.
    async buildUserLockTx(params) {
        const walletPublicKey = new PublicKey(this.signer.publicKey);
        const program = this.buildProgram(params.atomicContract, walletPublicKey);
        return buildUserLockTxFn(this.connection, program, walletPublicKey, params);
    }
    async buildRefundTx(params) {
        const walletPublicKey = new PublicKey(this.signer.publicKey);
        const program = this.buildProgram(params.contractAddress, walletPublicKey);
        return buildRefundTxFn(this.connection, program, walletPublicKey, params);
    }
    async buildRedeemSolverTx(params) {
        const walletPublicKey = new PublicKey(this.signer.publicKey);
        const program = this.buildProgram(params.contractAddress, walletPublicKey);
        return buildRedeemSolverTxFn(this.connection, program, walletPublicKey, params);
    }
}
